import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-purchased-supplements.reducer';

export const UserPurchasedSupplementsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userPurchasedSupplementsEntity = useAppSelector(state => state.userPurchasedSupplements.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userPurchasedSupplementsDetailsHeading">
          <Translate contentKey="fitengineerBackendV2App.userPurchasedSupplements.detail.title">UserPurchasedSupplements</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{userPurchasedSupplementsEntity.id}</dd>
          <dt>
            <span id="supplementSentDate">
              <Translate contentKey="fitengineerBackendV2App.userPurchasedSupplements.supplementSentDate">Supplement Sent Date</Translate>
            </span>
          </dt>
          <dd>
            {userPurchasedSupplementsEntity.supplementSentDate ? (
              <TextFormat value={userPurchasedSupplementsEntity.supplementSentDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="supplementDeliveredDate">
              <Translate contentKey="fitengineerBackendV2App.userPurchasedSupplements.supplementDeliveredDate">
                Supplement Delivered Date
              </Translate>
            </span>
          </dt>
          <dd>
            {userPurchasedSupplementsEntity.supplementDeliveredDate ? (
              <TextFormat value={userPurchasedSupplementsEntity.supplementDeliveredDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="fitengineerBackendV2App.userPurchasedSupplements.user">User</Translate>
          </dt>
          <dd>{userPurchasedSupplementsEntity.user ? userPurchasedSupplementsEntity.user.login : ''}</dd>
          <dt>
            <Translate contentKey="fitengineerBackendV2App.userPurchasedSupplements.productDeliveryStatus">
              Product Delivery Status
            </Translate>
          </dt>
          <dd>{userPurchasedSupplementsEntity.productDeliveryStatus ? userPurchasedSupplementsEntity.productDeliveryStatus.status : ''}</dd>
          <dt>
            <Translate contentKey="fitengineerBackendV2App.userPurchasedSupplements.transactionDetails">Transaction Details</Translate>
          </dt>
          <dd>{userPurchasedSupplementsEntity.transactionDetails ? userPurchasedSupplementsEntity.transactionDetails.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-purchased-supplements" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-purchased-supplements/${userPurchasedSupplementsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserPurchasedSupplementsDetail;
